import api from "./Api";

class TabelaNcmIBSCBSService {
  GetTabelaNcmIBSCBS(payload) {
    return api.get("/v1/tabelaNcmIBSCBS/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTabelaNcmIBSCBS(payload) {
    return api.post("/v1/tabelaNcmIBSCBS/", payload).then((response) => {
      return response.data;
    });
  }

  PutTabelaNcmIBSCBS(payload) {
    return api.put("/v1/tabelaNcmIBSCBS/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTabelaNcmIBSCBS(payload) {
    return api.delete("/v1/tabelaNcmIBSCBS/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTabelaNcmIBSCBSOData(payload) {
    return api.get("/OData/TabelaNcmIBSCBS" + payload).then((response) => {
      return response.data;
    });
  }

  AtualizarTabelaNcmIBSCBS(payload) {
    return api
      .post("/v1/tabelaNcmIBSCBS/AtualizarTabelaNcmIBSCBS", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new TabelaNcmIBSCBSService();
